module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/payroll/stepTwo/Summary.ejs -->\n';
 zakatColEnabled = payroll.get('zakat') > 0 
__p+='\n\n<div class="panel-body payroll-summary">\n    <div>\n        <strong>'+
((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
'</strong>\n        ';
 if (company.get('regNumber')) { 
__p+='\n            <small>('+
((__t=( company.get('regNumber') ))==null?'':_.escape(__t))+
')</small>\n        ';
 } 
__p+='\n    </div>\n\n    <h3>Payroll Summary For: End of '+
((__t=( payroll.getPeriodFormatted() ))==null?'':_.escape(__t))+
'</h3>\n\n    <table class="footable footable-summary footable-ellipsis table\n        table-stripped" data-striping="false">\n        <thead>\n            <tr class="first-header">\n                <th style=""></th>\n                <th style="width: 6%;"></th>\n                <th style="width: 13%;"></th>\n                <th style="width: 13%;"></th>\n                <th style="width: 6%;"></th>\n                ';
 if (zakatColEnabled) { 
__p+='\n                    <th style="width: 6%;"></th>\n                ';
 } 
__p+='\n                <th style="width: 19%;" class="employee contributions"\n                    colspan="4">\n                    Employee Contributions\n                </th>\n                <th style="width: 19%;" class="employer contributions"\n                    colspan="4">\n                    Employer Contributions\n                </th>\n                <th style="width: 6%;"></th>\n            </tr>\n            <tr class="second-header">\n                <th>Employee</th>\n                <th>Basic</th>\n                <th>Additions</th>\n                <th>Deductions</th>\n                <th>Gross</th>\n                ';
 if (zakatColEnabled) { 
__p+='\n                    <th class="">Zakat</th>\n                ';
 } 
__p+='\n                <th class="employee">PCB</th>\n                <th class="employee">EPF</th>\n                <th class="employee">SOCSO</th>\n                <th class="employee">EIS</th>\n                <th class="employer">EPF</th>\n                <th class="employer">SOCSO</th>\n                <th class="employer">EIS</th>\n                <th class="employer">HRDF</th>\n                <th>Net Pay</th>\n            </tr>\n        </thead>\n        <tbody>\n        ';
 payslips.forEach(function(payslip) { 
__p+='\n            ';
 employee = payslip.getEmployee() 
__p+='\n            ';
 details = payslip.getDetails() 
__p+='\n            ';
 additions = details.findByTypes(['addition', 'bonus', 'overtime']) 
__p+='\n            ';
 deductions = details.findByTypes(['unpaid_leave', 'deduction']) 
__p+='\n            <tr>\n                <td data-column="employeeName">\n                    <strong>'+
((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
'</strong>\n                    <div>'+
((__t=( employee.getPositionName() ))==null?'':_.escape(__t))+
'</div>\n                </td>\n                <td data-column="base">\n                    '+
((__t=( payslip.get('base').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td data-column="additions">\n                    '+
((__t=( payslip.get('additions').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    <div class="additions">\n                        ';
 additions.forEach(function(addition) { 
__p+='\n                            ';
 if (!addition.get('amount')) return; 
__p+='\n\n                            <div data-toggle="tooltip"\n                                data-placement="top" data-container="body"\n                                data-original-title="'+
((__t=( addition.getPayrollItemName() ))==null?'':_.escape(__t))+
'">\n                                ';
 /* formatted like this to avoid space before the colon */ 
__p+='\n                                '+
((__t=( addition.get('amount').formatWithoutRounding() ))==null?'':_.escape(__t))+
'';
 if (addition.isUnit()) { 
__p+='\n                                    (\n                                        '+
((__t=( (addition.get('unit') || 0) ))==null?'':_.escape(__t))+
' @\n                                        '+
((__t=( (addition.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                                    )\n                                ';
 } 
__p+=': '+
((__t=( addition.getPayrollItemName() ))==null?'':_.escape(__t))+
'\n                            </div>\n                        ';
 }) 
__p+='\n                    </div>\n                </td>\n                <td data-column="deductions">\n                    '+
((__t=( payslip.get('deductions').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n\n                    <div class="deductions">\n                        ';
 deductions.forEach(function(deduction) { 
__p+='\n                            ';
 if (
                                !deduction.get('amount') ||
                                !deduction.getPayrollItem().get('isNet')
                            ) return; 
__p+='\n\n                            <div data-toggle="tooltip"\n                                data-placement="top" data-container="body"\n                                data-original-title="'+
((__t=( deduction.getPayrollItemName() ))==null?'':_.escape(__t))+
'">\n                                ';
 /* formatted like this to avoid space before the colon */ 
__p+='\n                                - '+
((__t=( deduction.get('amount').formatWithoutRounding() ))==null?'':_.escape(__t))+
'';
 if (deduction.isUnit()) { 
__p+='\n                                    (\n                                        '+
((__t=( (deduction.get('unit') || 0) ))==null?'':_.escape(__t))+
' @\n                                        '+
((__t=( (deduction.get('rate') || 0) ))==null?'':_.escape(__t))+
'\n                                    )\n                                ';
 } 
__p+=': '+
((__t=( deduction.getPayrollItemName() ))==null?'':_.escape(__t))+
'\n                            </div>\n                        ';
 }) 
__p+='\n                    </div>\n\n                </td>\n                <td data-column="grossPay">\n                    <strong>\n                        '+
((__t=( payslip.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </strong>\n                </td>\n                ';
 if (zakatColEnabled) { 
__p+='\n                    <td data-column="zakat">\n                        '+
((__t=( payslip.get('zakat').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </td>\n                ';
 } 
__p+='\n                <td class="employee" data-column="mtd">\n                    ';
 mtdDetail = details.findByType('mtd').find(function (d) {
                        return d.getPayrollItem().get('subtype') !==
                            'custom';
                    }) 
__p+='\n                    ';
 if (
                        mtdTooltip &&
                        mtdDetail &&
                        mtdDetail.get('additionalInformation')
                    ) { 
__p+='\n                        <div data-toggle="tooltip"\n                            data-placement="right" data-container="body"\n                            data-html="true"\n                            data-delay="10000"\n                            data-original-title="\n                                '+
((__t=( require('./MTDTooltip.ejs')({
                                    data: mtdDetail.get('additionalInformation')
                                }) ))==null?'':__t)+
'">\n                            '+
((__t=( payslip.get('mtd').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                        </div>\n                    ';
 } else { 
__p+='\n                        '+
((__t=( payslip.get('mtd').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    ';
 } 
__p+='\n\n                    ';
 if ((payslip.get('cp38') || 0) > 0) { 
__p+='\n                        <div data-toggle="tooltip"\n                            data-placement="right" data-container="body"\n                            data-original-title="CP38">\n                            '+
((__t=( payslip.get('cp38').formatWithoutRounding() ))==null?'':_.escape(__t))+
': CP38\n                        </div>\n                    ';
 } 
__p+='\n                </td>\n                <td class="employee" data-column="employeeEpf">\n                    '+
((__t=( payslip.get('employeeEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td class="employee" data-column="employeeSocso">\n                    '+
((__t=( payslip.get('employeeSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td class="employee" data-column="employeeEis">\n                    '+
((__t=( (payslip.get('employeeEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td class="employer" data-column="employeeEpf">\n                    '+
((__t=( payslip.get('employerEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td class="employer" data-column="employerSocso">\n                    '+
((__t=( payslip.get('employerSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td class="employer" data-column="employerEis">\n                    '+
((__t=( (payslip.get('employerEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td class="employer" data-column="hrdf">\n                    '+
((__t=( (payslip.get('totalHrdf') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n                <td data-column="netPay">\n                    <strong>'+
((__t=( payslip.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</strong>\n                </td>\n            </tr>\n        ';
 }) 
__p+='\n        ';
 if (pagination && pagination.pages > 1) { 
__p+='\n            <tr>\n                <td>\n                    <strong>Page Total:</strong>\n                </td>\n                <td data-column="page-base">'+
((__t=( pageTotals.base.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td data-column="page-additions">'+
((__t=( pageTotals.additions.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td data-column="page-deductions">'+
((__t=( pageTotals.deductions.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td data-column="page-grossPay"><strong>'+
((__t=( pageTotals.grossPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</strong></td>\n                ';
 if (zakatColEnabled) { 
__p+='\n                    <td data-column="page-zakat">'+
((__t=( pageTotals.zakat.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                ';
 } 
__p+='\n                <td class="employee" data-column="page-mtd">'+
((__t=( (pageTotals.mtd + pageTotals.cp38).formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td class="employee" data-column="page-employeeEpf">'+
((__t=( pageTotals.employeeEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td class="employee" data-column="page-employeeSocso">'+
((__t=( pageTotals.employeeSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td class="employee" data-column="page-employeeEis">'+
((__t=( pageTotals.employeeEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td class="employer" data-column="page-employerEpf">'+
((__t=( pageTotals.employerEpf.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td class="employer" data-column="page-employerSocso">'+
((__t=( pageTotals.employerSocso.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td class="employer" data-column="page-employerEis">'+
((__t=( pageTotals.employerEis.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td class="employer" data-column="page-hrdf">'+
((__t=( (pageTotals.hrdf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n                <td data-column="page-netPay"><strong>'+
((__t=( pageTotals.netPay.formatWithoutRounding() ))==null?'':_.escape(__t))+
'</strong</td>\n            </tr>\n        ';
 } 
__p+='\n        <tr>\n            <td>\n                <strong>Grand Total:</strong>\n            </td>\n            <td data-column="total-base">'+
((__t=( payroll.get('base').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td data-column="total-additions">'+
((__t=( (payroll.get('additions') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td data-column="total-deductions">'+
((__t=( payroll.get('deductions').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td data-column="total-grossPay"><strong>'+
((__t=( payroll.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</strong></td>\n            ';
 if (zakatColEnabled) { 
__p+='\n                <td data-column="zakat">'+
((__t=( payroll.get('zakat').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            ';
 } 
__p+='\n            <td class="employee" data-column="total-mtd">'+
((__t=( (totals.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td class="employee" data-column="total-employeeEpf">'+
((__t=( payroll.get('employeeEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td class="employee" data-column="total-employeeSocso">'+
((__t=( payroll.get('employeeSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td class="employee" data-column="total-employeeEis">'+
((__t=( (payroll.get('employeeEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td class="employer" data-column="total-employerEpf">'+
((__t=( payroll.get('employerEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td class="employer" data-column="total-employerSocso">'+
((__t=( payroll.get('employerSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td class="employer" data-column="total-employerEis">'+
((__t=( (payroll.get('employerEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td class="employer" data-column="total-hrdf">'+
((__t=( (payroll.get('employerHRDF') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n            <td data-column="total-netPay"><strong>'+
((__t=( payroll.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</strong</td>\n        </tr>\n        </tbody>\n    </table>\n\n    ';
 if (pagination && pagination.pages > 1) { 
__p+='\n        <div class="container-fluid">\n            <ul class="pagination pull-right clearfix">\n                <li class="page-item '+
((__t=( pagination.page <= 0 ? 'disabled' : '' ))==null?'':_.escape(__t))+
'">\n                    <a aria-label="Previous" class="js-pagination-prev">\n                        <span aria-hidden="true">Previous</span>\n                    </a>\n                </li>\n                ';
 _.times(pagination.pages, function(i) { 
__p+='\n                    <li class="page-item '+
((__t=( pagination.page == i ? 'active' : '' ))==null?'':_.escape(__t))+
'">\n                        <a aria-label="Page '+
((__t=( i + 1 ))==null?'':_.escape(__t))+
'" data-page="'+
((__t=( i ))==null?'':_.escape(__t))+
'"\n                           class="js-pagination-page">\n                            <span aria-hidden="true">'+
((__t=( i + 1 ))==null?'':_.escape(__t))+
'</span>\n                        </a>\n                    </li>\n                ';
 }) 
__p+='\n                <li class="page-item '+
((__t=( pagination.page >= (pagination.pages - 1) ? 'disabled' : '' ))==null?'':_.escape(__t))+
'">\n                    <a aria-label="Next" class="js-pagination-next">\n                        <span aria-hidden="true">Next</span>\n                    </a>\n                </li>\n            </ul>\n            <span class="pull-right pagination-info">\n                Showing\n                '+
((__t=( pagination.offset + 1 ))==null?'':_.escape(__t))+
' to\n                '+
((__t=( Math.min(pagination.count, pagination.offset + pagination.limit) ))==null?'':_.escape(__t))+
'\n                of '+
((__t=( pagination.count ))==null?'':_.escape(__t))+
' employees\n            </span>\n        </div>\n    ';
 } 
__p+='\n\n    <div class="row total">\n        <div class="col-lg-8 col-md-12">\n            <div class="col-md-6 col-sm-12">\n                <div class="total-row">\n                    Number of Employees:\n                    <span class="pull-right">'+
((__t=( pagination.count ))==null?'':_.escape(__t))+
'</span>\n                </div>\n                <div class="total-row">\n                    Total Employee Net Pay:\n                    <span class="pull-right">\n                        '+
((__t=( payroll.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </span>\n                </div>\n            </div>\n            <div class="col-sm-6">\n                <div class="total-row">\n                    Total PCB payment:\n                    <span class="pull-right">\n                        '+
((__t=( (totals.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </span>\n                </div>\n                <div class="total-row">\n                    Total EPF payment:\n                    <span class="pull-right">\n                        '+
((__t=( (totals.epf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </span>\n                </div>\n                <div class="total-row">\n                    Total SOCSO payment:\n                    <span class="pull-right">\n                        '+
((__t=( (totals.socso || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </span>\n                </div>\n                <div class="total-row">\n                    Total EIS payment:\n                    <span class="pull-right">\n                        '+
((__t=( (totals.eis).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </span>\n                </div>\n\n                <div class="total-row">\n                    Total HRDF payment:\n                    <span class="pull-right">\n                        '+
((__t=( (payroll.get('employerHRDF') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </span>\n                </div>\n\n                ';
 if (payroll.get('zakat')) { 
__p+='\n                    <div class="total-row">\n                        Total Zakat payment:\n                        <span class="pull-right">\n                            '+
((__t=( (payroll.get('zakat') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                        </span>\n                    </div>\n                ';
 } 
__p+='\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/payroll/stepTwo/Summary.ejs
// module id = 745
// module chunks = 1